import ColorWebglProgram from "./colorWebglProgram";
export default class OptosWebglProgram extends ColorWebglProgram {
  constructor(vertexShaderText, fragmentShaderText){
    super(vertexShaderText, fragmentShaderText);
    this.greenBrightnessLocation = null;
    this.greenContrastLocation = null;
  }

  prepareLocations(gl){
    super.prepareLocations(gl);
    this.greenBrightnessLocation = gl.getUniformLocation(this.program, "u_green_brightness");
    this.greenContrastLocation = gl.getUniformLocation(this.program, "u_green_contrast");
  }

  setColorSettings(gl, colorSettings) {
    super.setColorSettings(gl, colorSettings);
    gl.uniform1f(this.greenBrightnessLocation, colorSettings.greenBrightness);
    gl.uniform1f(this.greenContrastLocation, colorSettings.greenContrast);
  }
}